// extracted by mini-css-extract-plugin
export default {"topmenu_list":"Switch_topmenu_list__oYSs+","active":"Switch_active__Y0PrX"};